export type TreeDimension = {
    width: number;
    height: number;
};

export const emptyTreeDimension: TreeDimension = { width: 0, height: 0 };
